// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpTagcntIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpTagcntIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpTagcntIconOutlined = function DrrpTagcntIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpTagcntIconOutlinedSvg
  }));
};

DrrpTagcntIconOutlined.displayName = 'DrrpTagcntIconOutlined';
export default React.forwardRef(DrrpTagcntIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpTagcntIconOutlined.js
// module id = 2584
// module chunks = 0